export default {
  'presentation.loading_pdf': 'PDF를 불러오는 중...',

  // 리모컨
  'remote.pause': '멈춤',
  'remote.reset': '리셋',
  'remote.reset_confirm': '타이머를 초기화할까요?',
  'remote.start': '시작',
  'remote.pointer_mode': '포인터 모드',
  'remote.laser': '레이저',
  'remote.highlight': '하이라이트',
  'remote.sketch': '스케치',
  'remote.magnifier': '돋보기',
  'remote.event_mode': '이벤트 모드',
  'remote.event_off': '이벤트{{number}} 끄기',
  'remote.event_on': '이벤트{{number}}',
  'remote.touch_laser': '터치하여 레이저 표시',
  'remote.highlight_size': '하이라이트 크기',
  'remote.touch_highlight': '터치하여 하이라이트 표시',
  'remote.sketch_settings': '스케치 설정',
  'remote.clear_all': '전체 지우기',
  'remote.pen_color': '펜 색상',
  'remote.pen_width': '펜 굵기',
  'remote.touch_draw': '터치하여 그리기',
  'remote.zoom_level': '확대 배율',
  'remote.touch_zoom': '터치하여 확대',
  'remote.controls': '컨트롤',
  'remote.notes': '노트',
  'remote.no_notes': '등록된 노트가 없습니다',
  'remote.notes_empty': '대시보드에서 노트를 추가하세요',
};
